import {deserialize, deserializeAs} from 'libs/cerialize';

export class ProfilePasswordModel {
	@deserialize
	NewPassword: string;

	@deserialize
	CurrentPassword: string;
}